import { render, staticRenderFns } from "./audit-ver-details.vue?vue&type=template&id=5fe97050&scoped=true"
import script from "./audit-ver-details.vue?vue&type=script&lang=js"
export * from "./audit-ver-details.vue?vue&type=script&lang=js"
import style0 from "./audit-ver-details.vue?vue&type=style&index=0&id=5fe97050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe97050",
  null
  
)

export default component.exports